export const itemHeight = 60;

export const chooserPanelMaxHeight = '300px';

export const batchSize = 20;
